import apiService from "api/apiService";
import { IServerResponse } from "redux/actions/appActions";

import { IBackgroundOperation } from "../types";

const BACKGROUND_OPERATIONS_ENDPOINT = "background_operations";

interface IFetchBackgroundOperationsResponse {
  background_operations: IBackgroundOperation[];
  total_count: number;
  limit: number;
  offset: number;
}

export interface IFetchBackgroundOperationsQuery {
  status?: string;
  workflow_status?: string;
  client_id?: string;
  operation_type?: string;
  workflow?: string;
  workflow_report?: string;
  workflow_step?: string;
  triggered_by?: string;
  error_message?: string;
  started_at_start?: string;
  started_at_end?: string;
  order_by?: string;
  order?: "asc" | "desc";
  limit?: number;
  offset?: number;
  all_clients?: boolean;
}

export type TFetchBackgroundOperationsOptions = {
  /** When true, append rows instead of replacing the list (pagination). */
  append?: boolean;
};

export const fetchBackgroundOperationsApiCall = (
  query: IFetchBackgroundOperationsQuery = {},
): Promise<IServerResponse<IFetchBackgroundOperationsResponse>> =>
  apiService.get(BACKGROUND_OPERATIONS_ENDPOINT, query);

interface ICancelBackgroundOperationResponse {
  background_operation: IBackgroundOperation;
}

export const cancelBackgroundOperationApiCall = (
  operationId: string,
): Promise<IServerResponse<ICancelBackgroundOperationResponse>> =>
  apiService.post(
    `${BACKGROUND_OPERATIONS_ENDPOINT}/${operationId}/cancel`,
    {},
    "CANCEL_BACKGROUND_OPERATION",
  );
